import useMutationCall from "../../../hooks/useMutationCall";
import { useRemoveSkillFromEmployeeMutation } from "../employeesSlice";

const useRemoveSkillFromEmployee = () => {
  return useMutationCall(useRemoveSkillFromEmployeeMutation);
};

export default useRemoveSkillFromEmployee;
